import React, { useDebugValue, useState } from 'react'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { Box, TextField } from '@mui/material'
import { FxLabel } from '../label/FxLabel'
import { FxDateProps } from './FxDate.props'
import { format, isValid } from "date-fns"
import { FxValidation } from '../validation/FxValidation'

/**
 *
 * @param label
 * @param name
 * @param onValueChange
 * @param value
 * @param size
 * @param info
 * @param variant
 * @param validations
 * @param type
 * @param labelAlignment
 * @constructor
 */
export const FxDate = ({
  label,
  name,
  path,
  onValueChange,
  value,
  size = "small",
  info,
  variant = "standard",
  validations,
  type = 'date',
  dateLabel,
  validationResult,
  disabled,
  labelAlignment = 'top',
  minDate,
  maxDate,
}: FxDateProps) => {
  const [onBlur, setOnBlur] = useState(false)
  const defaultCustomErrors: Array<any> = []
  const [customErrors, setCustomErrors] = useState(defaultCustomErrors)

  /**
   *
   * @param selectedValue
   */
  const onChange = (selectedValue: any) => {
    let val: any = "";
    if (selectedValue && !isValid(selectedValue)) {
      setCustomErrors([{ message: "Invalid Date!" }])
    } else {
      setCustomErrors([])
      if (type == "date") {
        val = isValid(selectedValue) ? format(selectedValue, 'yyyy-MM-dd') : ""
      } else if (type == "datetime") {
        val = isValid(selectedValue) ? format(selectedValue, 'yyyy-MM-dd HH:mm') : ""
      }
      onValueChange({
        name,
        value: val,
        path
      })
    }
  }

  console.log("date1 : ", value);

  const isMandatory = () => {
    if (validations && validations.length > 0) {
      return validations.includes('required')
    }
  };

  const showTextBoxLbl = () => {
    if (isMandatory() && dateLabel) {
      return <>
        {dateLabel} <span className="text-danger">*</span>
      </>
    } else if (dateLabel) {
      return <>{dateLabel}</>
    }
  }

  dateLabel = showTextBoxLbl()

  /**
   * 1. Element DatePicker doesn't have required attribute date
   * 2. Element DatePicker doesn't have required attribute openPicker
   * 3. Element DatePicker doesn't have required attribute rawValue
   */
  const renderLocalizationProvider = () =>
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      {type == "date" &&
        <DatePicker
          value={value}
          disabled={disabled}
          label={dateLabel}
          minDate={minDate}
          maxDate={maxDate}
          onChange={onChange}
          renderInput={(params: any) => <TextField size={size} fullWidth variant={variant}
            onFocus={() => setOnBlur(false)}
            onBlur={() => setOnBlur(true)} {...params} />}
        />
      }
      {type == "datetime" &&
        <DateTimePicker
          label={dateLabel}
          disabled={disabled}
          minDate={minDate}
          maxDate={maxDate}
          renderInput={(props) => <TextField
            onFocus={() => setOnBlur(false)}
            onBlur={() => setOnBlur(true)} {...props} />}
          value={value}
          onChange={onChange}
        />
      }
    </LocalizationProvider>

  return (
    <>
      <div className={`fx-date ${labelAlignment == 'top' ? 'alignmentTop' : 'alignmentLeft'}`}>
        {label && <div><FxLabel info={info} label={label} validations={validations} /></div>}
        {renderLocalizationProvider()}
      </div>
      <FxValidation name={name}
        value={value}
        validations={validations}
        validationResult={validationResult}
        onBlur={onBlur}
        customErrors={customErrors} />
    </>
  )
}
